export { default } from 'common/changesets/reset-password';
